module.exports = __webpack_public_path__ + "img/case4_mob.2a8b1544.jpg";